
import { computed, defineComponent, ref } from "vue";
import Sign from "@/components/Sign.vue";
import { SignData } from "@/types";
import { bananoUtil } from "@/util/banano";

export default defineComponent({
  name: "SendNft",
  components: {
    Sign,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    assetHash: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const banAddress = ref("");
    const addressPicked = ref(false);
    const invalidAddress = ref(false);
    const validateAddress = () => {
      if (!banAddress.value || !bananoUtil.isAccountValid(banAddress.value)) {
        invalidAddress.value = true;
      } else addressPicked.value = true;
    };

    const signData = computed<SignData>(() => ({
      type: "transaction",
      transaction: {
        amount: "1",
        destination: banAddress.value,
        representative: bananoUtil.getAddressFromBlockHash(props.assetHash),
      },
    }));

    return {
      banAddress,
      addressPicked,
      signData,
      invalidAddress,
      validateAddress,
    };
  },
});
